export default function EmptyState({ image, title, subtitle }) {
  return (
    <div className="relative text-center py-16 px-6 animate-fade-in-up">
      {/* Background pattern */}
      <div className="absolute inset-0 pattern-dots opacity-30 pointer-events-none"></div>

      {/* Decorative circles */}
      <div className="absolute top-10 left-1/4 w-24 h-24 bg-teal-500/5 rounded-full blur-2xl"></div>
      <div className="absolute bottom-10 right-1/4 w-32 h-32 bg-indigo-500/5 rounded-full blur-2xl"></div>

      {/* Content */}
      <div className="relative">
        {/* Image/Icon container */}
        <div className="mx-auto mb-6 w-32 h-32 relative">
          {/* Outer ring */}
          <div className="absolute inset-0 rounded-full border-2 border-dashed border-slate-200 animate-[spin_20s_linear_infinite]"></div>

          {/* Inner container */}
          <div className="absolute inset-2 rounded-full bg-gradient-to-br from-slate-50 to-slate-100 shadow-inner flex items-center justify-center">
            {image ? (
              <img
                src={image}
                alt="Empty state"
                className="w-20 h-20 object-contain opacity-80"
              />
            ) : (
              <svg
                className="w-12 h-12 text-slate-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                />
              </svg>
            )}
          </div>
        </div>

        {/* Text content */}
        <h2
          className="text-xl font-semibold text-slate-800 mb-2"
          style={{ fontFamily: 'var(--font-display)' }}
        >
          {title}
        </h2>
        <p
          className="text-sm text-slate-500 max-w-xs mx-auto leading-relaxed"
          style={{ fontFamily: 'var(--font-body)' }}
        >
          {subtitle}
        </p>

        {/* Decorative dots */}
        <div className="flex items-center justify-center gap-1.5 mt-6">
          <div className="w-1.5 h-1.5 rounded-full bg-teal-400"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-slate-300"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-slate-300"></div>
        </div>
      </div>
    </div>
  );
}
